import { createSelector } from 'reselect';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getZeroState } from '../../zero-state/selectors/getZeroState';
import { isFacebookMessengerSetup } from '../../zero-state/operators/getters';
export const getIsFacebookMessengerSetup = createSelector([getCurrentInboxId, getZeroState], (currentInboxId, zeroState) => {
  return isFacebookMessengerSetup(currentInboxId, zeroState);
});